<template>
  <div class="solutions">
    <div class="container">
      <div v-if="solution">
        <h1>{{ solution.title }}</h1>
        <p>{{ solution.desc }}</p>
      </div>

      <div v-if="!solutionCategories">
        <div class="vehicles" v-if="!isRoof()">
          <canopy-manufacturers
            v-on:selectCanopy="selectCanopy($event)"
            :selectedVehicle="selectedVehicle"
              :label_your_selected_canopy="label_your_selected_canopy"
              :label_manufacturer="label_manufacturer"
              :label_canopy="label_canopy"
              :label_select="label_select"
              :label_vehicle_type="label_vehicle_type"
              :label_change_canopy="label_change_canopy"
          ></canopy-manufacturers>
        </div>

        <div class="vehicles" v-if="isRoof()">
          <vehicle-drilldown
            v-on:selectVehicle="selectVehicle($event)"
            :label_manufacturer="label_manufacturer"
            :label_model="label_model"
            :label_year="label_year"
            :label_body_type="label_body_type"
            :label_loading="label_loading"
            :label_select="label_select"
            :label_select_vehicle="label_select_vehicle"
            :your_vehicle_is_set_to="your_vehicle_is_set_to"
            :label_change_vehicle="label_change_vehicle"
            :selectedVehicle="selectedVehicle"
            :link="link"
            :enable_rego_lookup="enable_rego_lookup"
          ></vehicle-drilldown>
        </div>

        <div v-if="selectedVehicle.full_name" dusk='solution_items' class="solution_items">
          <solution-items
            v-bind:solutionItems="solutionItems"
            v-on:showCategories="showCategories($event)"
            :selectedVehicle="selectedVehicle"
            :label_manufacturer="label_manufacturer"
            :label_model="label_model"
            :label_year="label_year"
            :label_body_type="label_body_type"
            :label_loading="label_loading"
            :label_select="label_select"
            :label_select_vehicle="label_select_vehicle"
            :your_vehicle_is_set_to="your_vehicle_is_set_to"
            :label_change_vehicle="label_change_vehicle"
            :label_vehicle_photo_shoot_promotion="label_vehicle_photo_shoot_promotion"
            :label_na_for_your_vehicle="label_na_for_your_vehicle"
            :label_begin="label_begin"
          ></solution-items>
        </div>
      </div>

      <div class="steps" v-if="solutionCategories" dusk='platform-type'>
        <platform-type
          v-bind:solutionCategories="solutionCategories"
          v-bind:categoryId="categoryId"
          v-on:categorySelected="categorySelected($event)"
          :label_na_for_your_vehicle="label_na_for_your_vehicle"
        ></platform-type>

        <item-step
          v-for="(item, index) in availableSpecifications"
          v-bind:key="item.key"
          v-bind:item="item"
          v-bind:index="index"
          v-bind:data="specificationData[index]"
          v-bind:step_value="selectedSpecifications[index]"
          v-bind:image_prefix="getImagePrefix(index)"
          v-on:selection="valueSelection(index, $event)"
          :id="'step' + index "
        ></item-step>

        <products
          v-bind:step_count="maxStep()"
          v-if="products"
          v-bind:product_items="products"
          v-bind:product_type="solutionItem.product_type"
          id="step_products"
          :currency_suffix="currency_suffix"
          :int_curr_symbol="int_curr_symbol"
          :label_complete_kit="label_complete_kit"
          :label_whats_included="label_whats_included"
          :label_qty="label_qty"
          :label_view="label_view"
          :label_solution="label_solution"
          :label_products="label_products"
          :label_Bar="label_Bar"
          :label_Bars="label_Bars"
          :hide_price_global_value="hide_price_global_value"
        ></products>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "solutions",
  props: {
    link: {
      type: String
    },
    solutionId: {
      type: String
    },
    label_manufacturer: {
      type: String,
      default: "Manufacturer"
    },
    label_model: {
      type: String,
      default: "Model"
    },
    label_year: {
      type: String,
      default: "Year"
    },
    label_body_type: {
      type: String,
      default: "Body Type"
    },
    label_loading: {
      type: String,
      default: "Loading"
    },
    label_select: {
      type: String,
      default: "Select"
    },
    label_select_vehicle: {
      type: String,
      default: "Select Vehicle"
    },
    label_change_vehicle: {
      type: String,
      default: "Change Vehicle"
    },
    your_vehicle_is_set_to: {
      type: String,
      default: "Your vehicle is set to"
    },
    currency_suffix: {
      type: String,
      default: "(RRP inc GST)"
    },
    int_curr_symbol: {
      type: String,
      default: "AUD"
    },
    label_vehicle_photo_shoot_promotion: {
        type: String,
        default: "Vehicle Photo Shoot Promotion"
    },
    label_your_selected_canopy: {
        type: String,
        default: "Your selected canopy"
    },
    label_canopy: {
        type: String,
        default: "Canopy"
    },
    label_vehicle_type: {
        type: String,
        default: "Vehicle Type"
    },
    label_change_canopy: {
        type: String,
        default: "Change canopy"
    },
    label_na_for_your_vehicle: {
        type: String,
        default: "Not available for your vehicle"
    },
    label_complete_kit: {
        type: String,
        default: "Complete Kit"
    },
    label_whats_included: {
        type: String,
        default: "What's Included"
    },
    label_qty: {
        type: String,
        default: "Qty"
    },
    label_view: {
        type: String,
        default: "View"
    },
    label_solution: {
        type: String,
        default: "Solution"
    },
    label_products: {
        type: String,
        default: "Products"
    },
    label_begin: {
        type: String,
        default: "Begin"
    },
    label_Bar: {
        type: String,
        default: "Bar"
    },
    label_Bars: {
        type: String,
        default: "Bars"
    },
    enable_rego_lookup: {
        type: String,
        default: "false"
    },
    hide_price_global_value: {
        type: String,
        default: "0"
    },
  },
  data: function() {
    return {
      solution: null,
      specifications: null,
      solutionItems: [],
      solutionCategories: null,
      selectedSpecifications: [],
      specificationData: [],
      products: [],
      solutionItem: null,
      selectedVehicle: {}
    };
  },
  mounted() {
    this.loadSolution();
  },
  computed: {
    availableSpecifications() {
      return this.specifications.filter((item, index) => {
        return this.shouldShow(index);
      });
    }
  },
  methods: {
    isRoof() {
      return !this.solution || this.solution.solution_type != 'canopy';
    },
    getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    },
    async selectVehicle(vehicle) {
      this.$store.commit("solutions/setSelectedVehicle", vehicle);
      this.selectedVehicle = vehicle;
      if (this.selectedVehicle && this.selectedVehicle.vehicleId) {
        let solutionItemsResponse = await axios.get(
          `api/solutions/${this.solutionId}/vehicle/${this.selectedVehicle.vehicleId}`
        );
        this.solutionItems = solutionItemsResponse.data.data;
      }

      ga('send','event', 'Fit My Vehicle', 'Selected Vehicle', vehicle.full_name);
      gtag('event', 'fit_my_vehicle_selected_vehicle', {'category':'Fit My Vehicle', 'action':vehicle.full_name});
    },
    async selectCanopy(vehicle) {
      this.selectedVehicle = vehicle;
      if (this.selectedVehicle && this.selectedVehicle.vehicleId) {
        let solutionItemsResponse = await axios.get(
          `api/solutions/${this.solutionId}/canopy/${this.selectedVehicle.vehicleId}`
        );
        this.solutionItems = solutionItemsResponse.data.data;
      }
    },
    maxStep() {
      if (this.products.length == 0) {
        return this.specifications.length + 2;
      } else {
        return this.specificationData.length + 2;
      }
    },
    shouldShow(index) {
      return (
        this.products.length == 0 || index < this.selectedSpecifications.length
      );
    },
    // Load the top level list of solutions; racks or trays
    async loadSolution() {
      let solutionsResponse = await axios.get(`api/solutions`);
      this.solution = solutionsResponse.data.data.filter(val => {
        if (val.solutionId == this.solutionId) {
          return true;
        }
      })[0];

      if (this.isRoof()) {
        var selected = this.$store.state.solutions.selectedVehicle;
        if (location.search == '?change') {
          window.history.replaceState('/', null, window.location.pathname);
        } else {
          if (selected && selected.full_name) {
            this.selectedVehicle = selected;
          }
        }
      }
      this.loadSolutionItems();
    },

    async loadSolutionItems() {

      if (this.selectedVehicle && this.selectedVehicle.vehicleId) {
          let solutionItemsResponse = await axios.get(
          `api/solutions/${this.solutionId}/vehicle/${this.selectedVehicle.vehicleId}`
        );

        this.solutionItems = solutionItemsResponse.data.data;


        if(this.getUrlParameter('s')) {
          for (var i = 0; i < this.solutionItems.length; i++) {
            if (this.solutionItems[i].itemId == this.getUrlParameter('s')) {
              this.showCategories(this.solutionItems[i], true);
            }
          }
        }
      }

    },

    // After a solution has been selected, showing the list of available categories for that solution, including the specifications they can step through
    async showCategories($event, ignoreUrl) {
      this.solutionItem = $event;
      let response = await axios.get(this.getVehicleUrl());
      this.solutionCategories = response.data.data;
      this.specifications = response.data.data.specifications;
      if (!ignoreUrl) {
        this.setUrl();
      } else {
        if(this.getUrlParameter('c')) {
          this.categorySelected(this.getUrlParameter('c'), true);
        }
      }
    },

    setUrl() {
      var path = window.location.pathname;
      if (this.solutionItem) {
        path = path + '?s=' + this.solutionItem.itemId;
      }
      if (this.categoryId) {
        path = path + '&c=' + this.categoryId
      }
      if (this.selectedSpecifications.length > 0) {
        var ps = [];
        for(var i = 0; i < this.selectedSpecifications.length; i++) {
          ps.push(this.selectedSpecifications[i]);
        }
        path = path + '&p=' + ps.join(',')
      }
      window.history.replaceState({}, null, path)
    },

    // When a user selects a category
    categorySelected(category, ignoreUrl) {
      this.categoryId = category;
      this.selectedSpecifications = [];
      this.specificationData = [];
      this.products = [];
      if (this.specifications.length > 0) {

        if(this.getUrlParameter('p')) {
          var selectedSpecifications = this.getUrlParameter('p').split(',');
          if (selectedSpecifications.length > 0) {
            this.getData(selectedSpecifications)
          }
        } else {
          this.getData();
        }
      } else {
        this.getProductData();
      }
      this.scrollToView("step" + this.selectedSpecifications.length);

      if (!ignoreUrl) {
        this.setUrl();
      }
    },

    // Once the user has selected the category for a solution, they will be able to select specifications
    valueSelection(index, $event, additional) {
      this.selectedSpecifications[index] = $event;
      this.selectedSpecifications = this.selectedSpecifications.slice(
        0,
        index + 1
      );
      this.products = [];

      var load_products = false;

      for (var i = 0; i < this.specificationData[index].length; i++) {
        if (
          this.specificationData[index][i].specificationPropertyMasterDataId ===
            $event &&
          this.specificationData[index][i].product_count == 1
        ) {
          //load_products = true;
        }
      }

      if (this.selectedSpecifications.length >= this.specifications.length) {
        load_products = true;
      }

      if (load_products) {
        this.getProductData();
        this.scrollToView("step_products");
      } else {
        this.getData(additional);
        this.scrollToView("step" + this.selectedSpecifications.length);
      }
    },

    // For each step in the process, go and get the data for the currently selected step
    async getData(additional) {
      var specifications = this.specifications;

      // create data to send
      let data = {
        categoryId: this.categoryId,
        results: false
      };

      for (var i = 0; i < specifications.length; i++) {
        if (this.selectedSpecifications.length > i) {
          data[specifications[i].key] = this.selectedSpecifications[i];
        } else {
          data[specifications[i].key] = "null";
        }
      }

      // request data from api
      let response = await axios.post(this.getVehicleUrl(), data);

      this.specificationData[this.selectedSpecifications.length] = response.data.data.items;
      this.specificationData = this.specificationData.slice(0, this.selectedSpecifications.length + 1);

      if (response.data.data.items.length == 0) {
        this.getProductData();
      } else if (response.data.data.items.length == 1 && !(additional && additional.length > 0)) {
        this.valueSelection(this.selectedSpecifications.length, response.data.data.items[0].specificationPropertyMasterDataId, additional ? additional.slice(1) : null)
      }
      if (additional && additional.length > 0) {
        this.valueSelection(this.selectedSpecifications.length, additional[0], additional.slice(1));
      } else {
        this.setUrl();
      }
    },

    // Load the list of products
    async getProductData() {
      this.products = [];

      // create data to send
      let data = {
        categoryId: this.categoryId,
        results: true
      };

      for (var i = 0; i < this.specifications.length; i++) {
        if (this.selectedSpecifications.length > i) {
          data[this.specifications[i].key] = this.selectedSpecifications[i];
        } else {
          data[this.specifications[i].key] = "null";
        }
      }

      // request data from api

      let response = await axios.post(this.getVehicleUrl(), data);
      this.products = response.data.data.items;
    },

    scrollToView(id) {
      let ctrl = document.getElementById(id);
      if (ctrl) {
        ctrl.scrollIntoView();
      }
    },

    getVehicleUrl() {
      return `api/solutions/item/${this.solutionItem.itemId}/${
        this.solution.solution_type == "roof" ? "vehicle" : "canopy"
      }/${this.selectedVehicle.vehicleId}`;
    },

    getImagePrefix(index, code) {
      var items = [];
      for (var i = 0; i < this.solutionCategories.categories.length; i++) {
        if (this.solutionCategories.categories[i].categoryId == this.categoryId) {
          items.push(this.slugify(this.solutionCategories.categories[i].title));
        }
      }

      var specifications = this.selectedSpecifications.slice(0, index);
      for (var i = 0; i < specifications.length; i++) {
        for(var ii = 0; ii < this.specificationData.length; ii++ ) {
          if (this.specificationData[ii]) {
            for(var iii = 0; iii < this.specificationData[ii].length; iii++ ) {
              if (this.specificationData[ii][iii].specificationPropertyMasterDataId == specifications[i]) {
                var value = this.slugify(this.specificationData[ii][iii].title);
                items.push(value);
              }
            }
          }
        }
      }
      /*if (this.selectedSpecifications.length > index) {
        return this.categoryId + '-' + this.selectedSpecifications.slice(0, index).join('-');
      } else {
        return this.categoryId;
      }*/
      return (items.join('-') + '-')
        .replace('-overhang-bar-', '-')
        .replace('-flush-bar-', '-')
        .replace('-silver-', '-')
        .replace('-black-', '-');
    },

    slugify(string) {
      const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
      const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
      const p = new RegExp(a.split('').join('|'), 'g')

      return string.toString().toLowerCase()
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
        .replace(/&/g, '-and-') // Replace & with 'and'
        .replace(/[^\w\-]+/g, '') // Remove all non-word characters
        .replace(/\-\-+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, '') // Trim - from end of text
    }
  }
};
</script>
